"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _locale = require("../locale");

var _icons = _interopRequireDefault(require("../icons"));

var _uid = require("../utils/uid");

var _List = _interopRequireDefault(require("../List"));

var _Spin = _interopRequireDefault(require("../Spin"));

var _Input = _interopRequireDefault(require("../Input"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _styles = require("../styles");

var _BoxOption = _interopRequireDefault(require("./BoxOption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var ScaleList = (0, _List.default)(['fade', 'scale-y'], 'fast', 'flex');

var emptyFunc = function emptyFunc() {};

var BoxList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(BoxList, _Component);

  function BoxList(props) {
    var _this;

    _this = _Component.call(this, props) || this; // fake events

    props.bindOptionFunc('handleHover', emptyFunc);
    props.bindOptionFunc('hoverMove', emptyFunc);
    props.bindOptionFunc('getIndex', emptyFunc);
    _this.handleSelectAll = _this.handleSelectAll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = BoxList.prototype;

  _proto.getText = function getText(key) {
    return this.props.text[key] || (0, _locale.getLocale)(key);
  };

  _proto.handleSelectAll = function handleSelectAll(_, checked) {
    var _this$props = this.props,
        datum = _this$props.datum,
        data = _this$props.data;
    if (checked) datum.add(data);else datum.remove(data);
  };

  _proto.handleSearch = function handleSearch(text) {
    this.props.onFilter(text);
  };

  _proto.renderFilter = function renderFilter() {
    var filterText = this.props.filterText;
    return _react.default.createElement(_Input.default.Group, {
      size: "small",
      className: (0, _styles.selectClass)('filter-input')
    }, _react.default.createElement(_Input.default, {
      value: filterText,
      onChange: this.handleSearch
    }), _icons.default.SEARCH);
  };

  _proto.renderHeader = function renderHeader(count) {
    var _this$props2 = this.props,
        data = _this$props2.data,
        loading = _this$props2.loading,
        multiple = _this$props2.multiple;
    if (loading || !multiple) return null;
    var checked = 'indeterminate';
    if (count === 0) checked = false;else if (count === data.length) checked = true;
    return _react.default.createElement("div", {
      className: (0, _styles.selectClass)('header')
    }, multiple && _react.default.createElement(_Checkbox.default, {
      onChange: this.handleSelectAll,
      checked: checked
    }, this.getText('selectAll')));
  };

  _proto.renderOptions = function renderOptions(options) {
    var loading = this.props.loading;
    if (loading) return null;
    return _react.default.createElement("div", {
      className: (0, _styles.selectClass)('box-options')
    }, options);
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        columnWidth = _this$props3.columnWidth,
        columns = _this$props3.columns,
        data = _this$props3.data,
        datum = _this$props3.datum,
        keygen = _this$props3.keygen,
        multiple = _this$props3.multiple,
        style = _this$props3.style,
        loading = _this$props3.loading,
        renderItem = _this$props3.renderItem,
        focus = _this$props3.focus,
        onChange = _this$props3.onChange,
        selectId = _this$props3.selectId;
    var options = [];

    if (data.length === 0) {
      options.push(_react.default.createElement("div", {
        key: "empty",
        className: (0, _styles.selectClass)('no-data')
      }, this.getText('noData')));
    }

    var checkedCount = 0;
    data.forEach(function (d, i) {
      var isActive = datum.check(d);
      if (isActive) checkedCount += 1;
      options.push(_react.default.createElement(_BoxOption.default, {
        key: (0, _uid.getKey)(d, keygen, i),
        isActive: isActive,
        disabled: datum.disabled(d),
        data: d,
        columns: columns,
        multiple: multiple,
        onClick: onChange,
        renderItem: renderItem
      }));
    });
    var newStyle = Object.assign({}, style, {
      width: columnWidth * columns
    });
    return _react.default.createElement(ScaleList, {
      show: focus,
      onMouseMove: this.handleMouseMove,
      "data-id": selectId,
      style: newStyle,
      className: (0, _styles.selectClass)('box-list')
    }, loading && typeof loading === 'boolean' ? _react.default.createElement(_Spin.default, {
      size: 30
    }) : loading, this.renderHeader(checkedCount), this.renderOptions(options));
  };

  return BoxList;
}(_react.Component);

BoxList.propTypes = {
  bindOptionFunc: _propTypes.default.func.isRequired,
  columnWidth: _propTypes.default.number,
  columns: _propTypes.default.number,
  data: _propTypes.default.array,
  datum: _propTypes.default.object.isRequired,
  filterText: _propTypes.default.string,
  focus: _propTypes.default.bool,
  keygen: _propTypes.default.any,
  loading: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool]),
  multiple: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onFilter: _propTypes.default.func,
  renderItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  selectId: _propTypes.default.string,
  style: _propTypes.default.object,
  text: _propTypes.default.object
};
BoxList.defaultProps = {
  columnWidth: 160
};
var _default = BoxList;
exports.default = _default;